function AFMultiLanguagePlugin() {
	var $ = jQuery;
	var thisObject = this;
	this.reCreate = function() {
		$( '[data-multi-language-plugin]' ).each( function() {
			var $this = $( this );
			if ( ! $this.data( 'multiLanguagePluginRunning' ) ) {

				$this.data( 'multiLanguagePluginRunning', true );
			}
		} );
	};

	// on ready
	$( function() {
		thisObject.reCreate();

		// on update page
		$( 'body' ).on( 'click', '[data-multi-language-plugin]', function( event ) {
			var $a;
			var languageIso2Code;
			var domain;
			var secure;

			event.preventDefault();
			$a = $( this );
			languageIso2Code = $a.data( 'multiLanguagePluginIso2Code' );
			secure = ( 'https:' === window.location.protocol );
			domain = document.location.host.replace( /^.*\.([\w\W]+?\.[\w\W]+$)/, '$1' );
			wpCookies.set( 'afml', languageIso2Code, 365 * 24 * 60 * 60, '/', domain, secure );
			document.location = this.href;
		} );

	} );

	// on update page
	$( document ).on( 'update', function() {
		thisObject.reCreate();

	} );

};

